import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AbsencePeriod } from 'cb-model';
import {
  Display,
  fetchApi,
  FormButtons,
  makeResetCache,
  notify,
  PageTitle,
  QuerySingle,
  Section,
} from 'gossamer-front-end';
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';

export const AbsencePeriodDelete = (): React.JSX.Element => {
  const params = useParams();
  const [submitting, setSubmitting] = React.useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resetCache = makeResetCache(dispatch);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await fetchApi('POST', '/main/~/absence-period-delete', {
        transId: uuid(),
        rows: [
          {
            entityId: AbsencePeriod.id,
            key: params.key,
            action: 'D',
          },
        ],
      });
      resetCache(AbsencePeriod.id);
      notify(['Delete successful', 'success']);
      navigate('/admin/absence-period/search');
    } catch (e) {
      console.error(e);
      notify(['An error occurred', 'danger']);
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/admin/absence-period/search');
  };

  return (
    <>
      <PageTitle
        verb="Delete"
        entity={AbsencePeriod}
        keyValue={params.key}
        subtitle="Delete this Absence Period and all associated user records"
      />

      <Section>
        <QuerySingle entity={AbsencePeriod} keyValue={params.key} render={Display} />
      </Section>
      <Section>
        <FormButtons handleSubmit={handleSubmit} handleCancel={handleCancel} submitting={submitting} />
      </Section>
    </>
  );
};
